export default "어떻게\n왜\n얼마나"